import * as React from 'react';
import { useSelector } from 'react-redux';

import { Roads } from '../../components/Roads';
import { getRoadInfo } from '../../selectors/newbuilding';

export function RoadsContainer() {
  const roads = useSelector(getRoadInfo);

  if (!(roads && roads.length)) {
    return null;
  }

  return <Roads roads={[roads[0]]} />;
}
